import AccessoryListComponent from "./components/accessory-list-component";
import {isEmptyObject} from "./utils/is-empty-object";
import {render, RenderPosition} from "./utils/render";

export const renderAccessories = (container, className, addition) => {
  if (!addition || !addition.groups || isEmptyObject(addition.groups)) {
    return;
  }

  const component = new AccessoryListComponent({
    className,
    title: addition.title,
    items: addition.groups,
  });

  render(container, component.getElement(), RenderPosition.BEFOREEND);
};
